import { IBaseFormulierPageProps, SchemaToRequestMapper } from "@klantondersteuning/shared";
import * as React from "react";
import { GetBewindvoerdersCuratorenClientWijzigenFormulier } from "../schema/BewindvoerdersCuratorenClientWijzigenFormulier";
import { FormulierPage } from "./FormulierPageWrapper";

export const BewindvoerdersCuratorenClientWijzigenFormulierPage = (
  props: Readonly<IBaseFormulierPageProps>
) => {
  return (
    <FormulierPage
      pageBaseUrl={props.pageBaseUrl}
      basePath={props.basePath}
      apiUrl={props.apiUrl}
      language={props.language}
      formDefinition={GetBewindvoerdersCuratorenClientWijzigenFormulier()}
      formulierKenmerk="bewindvoerders-curatoren-client-wijzigen"
      schemaToRequestMapper={new SchemaToRequestMapper()}
    />
  );
};
